import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';



import { Checkbox, FormControlLabel } from '@mui/material';



import { palette } from 'styles/mui/scss';



import { Box, Typography } from 'components/basic-components';
import { CustomIcon } from 'components/basic-components/CustomIcon/CustomIcon';



import styles from './styles/CarFilterCheckbox.module.scss';
import { checkProperties } from './utils/checkProperties';


const CarFilterCheckbox = ({label, name, data, iconName}) => {
  const {control, getValues} = useFormContext();
  const formValues = getValues();
  const isDisabled = checkProperties(data, name, formValues.type);
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={false}
      render={({field: {value, onChange}}) => (
        <FormControlLabel
          className={styles.formControlLabel}
          sx={{
            backgroundColor: value ? 'rgba(254, 237, 1, 0.15)' : '#f7f7f7',
            '& *': {color:isDisabled ? palette.colorGrey20 : palette.colorGrey80 },
          }}
          control={<Checkbox className={styles.checkbox} checked={value} onChange={onChange} />}
          disabled={isDisabled}
          // disabled
          label={
            <Box className={styles.labelWrapper}>
              <CustomIcon name={iconName} className={styles.icon} />
              <Typography variant="buttonCards" className={styles.label}>
                {label}
              </Typography>
            </Box>
          }
        />
      )}
    />
  );
};
export default CarFilterCheckbox;